/* global attachEvent */
// *******************************************************************************
// File upload
// *******************************************************************************

const fileUploadInput = document.querySelectorAll('.mod-file-upload__input');
fileUploadInput.forEach((el) => {
  const label = el.nextElementSibling;
  const parentElem = el.closest('.mod-file-upload');
  const selectedList = parentElem.querySelector('.mod-file-upload__list');
  const selectedListText = parentElem.querySelector('.mod-file-upload__list-text');
  const labelVal = label.innerHTML;

  el.addEventListener('change', function (e) {
    let fileName = '';
    if (this.files && this.files.length > 1) {
      fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
    } else {
      fileName = e.target.value.split('\\').pop();
    }

    selectedList.classList.toggle('hide', !fileName);
    parentElem.classList.toggle('is-selected', fileName);
    selectedListText.innerHTML = fileName || labelVal;
  });
});

// Remove item
attachEvent('.mod-file-upload__list-remove', 'click', (el) => {
  const parentElem = el.target.closest('.mod-file-upload');
  const selectedList = parentElem.querySelector('.mod-file-upload__list');
  const fileInput = parentElem.querySelector('.mod-file-upload__input');
  selectedList.classList.add('hide');
  fileInput.value = '';
});
